import { ReactElement } from 'react';

import { useChooseSubscriptionRedirect } from '~/hooks/useChooseSubscriptionRedirect';

import { AuthenticatedLayout, AuthenticatedLayoutProps } from '../AuthenticatedLayout';

import { Navbar } from '../components';

export type CustomerLayoutProps = AuthenticatedLayoutProps;

export const CustomerLayout = ({ children, ...rest }: CustomerLayoutProps): ReactElement => {
  useChooseSubscriptionRedirect();

  return (
    <AuthenticatedLayout {...rest} navigation={<Navbar />}>
      {children}
    </AuthenticatedLayout>
  );
};
